import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

export interface PaymentStatusChipProps {
  status: string;
}

const COLORS: Record<string, { label: string; color: string; bg: string }> = {
  PAGO: { label: 'Pago', color: '#28a745', bg: 'rgba(40,167,69,0.2)' },
  PENDENTE: { label: 'Pendente', color: '#f0ad4e', bg: 'rgba(240,173,78,0.2)' },
  CANCELADO: { label: 'Cancelado', color: '#6c757d', bg: 'rgba(108,117,125,0.2)' },
  ESTORNADO: { label: 'Estornado', color: '#17a2b8', bg: 'rgba(23,162,184,0.2)' },
  // Sem esta entrada o fallback renderiza a string crua do enum -- "GRATUITO" em caixa
  // alta, ao lado de irmãs em "Pendente"/"Estornado". Passou despercebido enquanto as
  // abas de Recebimentos filtravam GRATUITO fora da lista; a inclusão pedida pelo owner
  // em 2026-09-01 expôs. Verde como PAGO por pertencer à mesma família (nada a receber,
  // situação resolvida), num tom mais escuro para não se confundir com ele.
  GRATUITO: { label: 'Gratuito', color: '#198754', bg: 'rgba(25,135,84,0.2)' },
  PEDIDO_REEMBOLSO: { label: 'Pedido reembolso', color: '#6f42c1', bg: 'rgba(111,66,193,0.2)' },
};

const PaymentStatusChip: React.FC<PaymentStatusChipProps> = ({ status }) => {
  const cfg = COLORS[status] || { label: status, color: '#6c757d', bg: 'rgba(108,117,125,0.2)' };
  return (
    <Chip
      label={cfg.label}
      className='ps-2'
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 },
      }}
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }} />}
      size="small"
    />
  );
};

export default PaymentStatusChip;
